import VeeValidate, { Validator } from 'vee-validate'
import de from '@/i18n/vee-validate/de'

/**
* Sets up the validation framework vee-validate.
* @param Vue: the global Vue object
* @param locale: the language for validation error messages (optional; can be
* changed by setting Validator.locale)
*/
export function setupValidation (Vue, locale) {
  // Load localizations (en is included automatically)
  // To add more languages: http://vee-validate.logaretm.com/localization.html
  Validator.localize('de', de)

  // Set initial language
  Validator.locale = locale

  // Register plugin
  Vue.use(VeeValidate)
}

/**
* TODO
*/
export function updateValidationLanguage (newLanguage) {
  Validator.locale = newLanguage
}



// WEBPACK FOOTER //
// ./src/core/setup-validation.js